import { Column } from '../../../../../components/Table/types';
import { Columns } from "./types";

const columns: Column<Columns>[] = [
  { label: "ID товара", name: "id" },
  { label: "Артикул товара", name: "article" },
  { label: "Статус обновления", name: "status" },
];

export const columnPrice:Column<Extract<Columns, 'price'>> = 
{ label: "Цена", name: "price" };
export const columnDiscount:Column<Extract<Columns, 'discount'>> = 
{ label: "Скидка", name: "discount" };
export const columnPriceBeforeDiscount:Column<Extract<Columns, 'priceBeforeDiscount'>> = 
{ label: "Цена до скидок", name: "priceBeforeDiscount" };

export const columnMinPrice:Column<Extract<Columns, 'minPrice'>> =
    { label: "Мин.цена для скидки", name: "minPrice" };


export default columns;
